import {
  CanActivate,
  Router,
  UrlTree
} from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable, from } from "rxjs";

import { AuthService } from "./auth.service";

@Injectable()
export class AuthGuardAdmin implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return from(this.authService.guardAdminWithCompleteProfile());
  }
  
}
